import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../fragments/button';

export default class SubmitButton extends React.Component {

  static propTypes = {
    reference: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  handleClick(e) {
    e && e.preventDefault();
    const {onSubmit} = this.props;
    onSubmit();
  }

  render() {
    // const {reference} = this.props;
    return (
      <Button
       onClick={this.handleClick.bind(this)}
       type="submit"
       btnStyle="primary">
        {/* {reference.id? 'Update study': 'Enter this study'} */}
        Enter isolate data
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-edit/submitBtn.js